import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=07e0d94b&scoped=true&"
import script from "./EventForm.vue?vue&type=script&lang=ts&"
export * from "./EventForm.vue?vue&type=script&lang=ts&"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=07e0d94b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e0d94b",
  null
  
)

export default component.exports